import axiosInstance from '@/app/api/axiosInstance';
import { UserProfile } from '@/app/types/auth';
import { UserPreferenceResponse, UserPreferenceUpdate } from '@/app/types/user_preference';

export interface UserListResponse {
  items: UserProfile[];
  total: number;
  skip: number;
  limit: number;
}

export const getCurrentUserInfo = async (): Promise<UserProfile> => {
  try {
    const response = await axiosInstance.get<UserProfile>('/users/me');
    console.log('Fetched user info:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to get current user info:', error);
    throw error;
  }
};

export const getUserPreferences = async (): Promise<UserPreferenceResponse> => {
  try {
    const response = await axiosInstance.get<UserPreferenceResponse>('/user-preferences/me');
    return response.data;
  } catch (error) {
    console.error('Failed to get user preferences:', error);
    throw error;
  }
};

export const updateUserPreferences = async (data: UserPreferenceUpdate): Promise<UserPreferenceResponse> => {
  try {
    const response = await axiosInstance.patch<UserPreferenceResponse>('/user-preferences/me', data);
    return response.data;
  } catch (error) {
    console.error('Failed to update user preferences:', error);
    throw error;
  }
};

export const listUsers = async (params?: { limit?: number; skip?: number }): Promise<UserListResponse> => {
  try {
    const response = await axiosInstance.get<UserListResponse>('/users/', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to list users:', error);
    throw error;
  }
}; 